// extracted by mini-css-extract-plugin
export default {"red":"ColoredText__red-qzzpG","green":"ColoredText__green-xh5V6","yellow":"ColoredText__yellow-yzVAh","grey":"ColoredText__grey-_34y6"};